import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { CreateStripeBillingPortalRequestBody } from "@syla/shared/types/requests/CreateStripeBillingPortalRequest";
import { CreateStripeBillingPortalResponse } from "@syla/shared/types/responses/CreateStripeBillingPortalResponse";
import axios from "axios";

export const createStripeBillingPortalSession = async (
  props: CreateStripeBillingPortalRequestBody
): Promise<TransportType<CreateStripeBillingPortalResponse>> => {
  const { data } = await axios.post(
    "/plans/create-stripe-billing-portal-session",
    props
  );
  return data;
};
